import { useTranslation } from 'react-i18next'
import { useToggle } from '@ocean/hooks'
import { Mode } from '@ocean/types/dist/appearance'
import { controls } from '@ocean/ui'
import { namespace } from 'core/userDeclaration/localization'
import { ModalConfirmationLayout, ModalConfirmationLayoutSegment } from 'layouts'

const { Checkbox, Button, ButtonVariant } = controls

const I18_PATH = `${namespace}:userDeclaration`

type UserDeclarationProps = {
  endUserDeclarationText: string
  onAcceptance: Callback
}

// NOTE: Reused for Simulator Training fees confirmation
const UserDeclaration: React.FC<UserDeclarationProps> = ({
  endUserDeclarationText,
  onAcceptance,
}) => {
  const { value: isAccepted, toggle: setAcceptance } = useToggle(false)
  const { t } = useTranslation()

  return (
    <ModalConfirmationLayout>
      <ModalConfirmationLayoutSegment segmentId='content'>
        <div
          dangerouslySetInnerHTML={{ __html: endUserDeclarationText }}
          data-test='UserDeclarationContent'
        />
      </ModalConfirmationLayoutSegment>
      <ModalConfirmationLayoutSegment segmentId='actions'>
        <Checkbox
          checked={isAccepted}
          title={t(`${I18_PATH}.iAgreeTo`)}
          onChange={setAcceptance}
          mode={Mode.Light}
          dataTest='UserDeclarationIAgreeTo'
        />
        <Button
          disabled={!isAccepted}
          variant={ButtonVariant.Primary}
          onClick={onAcceptance}
          title={t(`${I18_PATH}.accept`)}
          dataTest='UserDeclarationAcceptanceButton'
        />
      </ModalConfirmationLayoutSegment>
    </ModalConfirmationLayout>
  )
}

export default UserDeclaration
